import moment from 'moment'

export const dateIntervals = {
  START_OF_TODAY: moment().utc().startOf('day'),
  END_OF_TODAY: moment().utc().endOf('day'),
  ONE_DAY_AGO: moment().utc().subtract('1', 'days').startOf('day'),
  ONE_WEEK_AGO: moment().utc().subtract('1', 'week').startOf('day'),
  ONE_MONTH_AGO: moment().utc().subtract('1', 'month').startOf('day'),
  THREE_MONTHS_AGO: moment().utc().subtract('3', 'month').startOf('day'),
  SIX_MONTHS_AGO: moment().utc().subtract('6', 'month').startOf('day')
}
